<template>
  <section class="product-blockchain" id="on-chain-data">
    <div class="section-inner">
      <div class="content-wrapper">
        <div class="text-content">
          <p class="section-label fade-in-section">{{ t('home.blockchain.label') }}</p>
          <h2 class="section-title fade-in-section">{{ t('home.blockchain.title') }}</h2>
          <p class="section-subtitle fade-in-section">{{ t('home.blockchain.subtitle') }}</p>
          <p class="section-description fade-in-section">{{ t('home.blockchain.description') }}</p>

          <ul class="feature-list">
            <li
              v-for="featureKey in featureKeys"
              :key="featureKey"
              class="feature-item fade-in-section"
            >
              <span class="feature-dot" aria-hidden="true"></span>
              <div>
                <div class="feature-title">{{ t(`home.blockchain.features.${featureKey}.title`) }}</div>
                <div class="feature-description">{{ t(`home.blockchain.features.${featureKey}.description`) }}</div>
              </div>
            </li>
          </ul>

          <div class="action-row fade-in-section">
            <router-link class="btn btn-primary" to="/on-chain-data">
              {{ t('home.blockchain.cta') }}
            </router-link>
          </div>
        </div>

        <div class="image-content fade-in-section">
          <img
            :src="productImage"
            :alt="t('home.blockchain.title')"
            class="product-image"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useTranslation } from '@/utils/i18n'

const productImage = require('@/assets/img/home/product-on-chain-data.png')

export default {
  name: 'ProductBlockchain',
  setup() {
    const { t } = useTranslation()
    const featureKeys = ['feature1', 'feature2', 'feature3', 'feature4']

    return {
      t,
      productImage,
      featureKeys
    }
  }
}
</script>

<style lang="scss" scoped>
.product-blockchain {
  padding: 96px 20px;
  background: #ffffff;
}

.section-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.content-wrapper {
  display: grid;
  grid-template-columns: 0.95fr 1.05fr;
  gap: 48px;
  align-items: center;
}

.section-label {
  margin: 0 0 12px;
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #1a7fb0;
  font-family: 'Aileron-Bold', sans-serif;
}

.section-title {
  margin: 0 0 16px;
  font-size: clamp(24px, 3vw, 34px);
  line-height: 1.25;
  color: #0b2238;
  font-family: 'Aileron-Bold', sans-serif;
}

.section-subtitle {
  margin: 0 0 12px;
  font-size: 16px;
  line-height: 1.7;
  color: #4a6075;
  font-family: 'Aileron-Regular', sans-serif;
}

.section-description {
  margin: 0 0 24px;
  font-size: 14px;
  line-height: 1.7;
  color: #52667a;
  font-family: 'Aileron-Regular', sans-serif;
}

.feature-list {
  list-style: none;
  margin: 0 0 28px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.feature-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.feature-dot {
  width: 8px;
  height: 8px;
  margin-top: 8px;
  border-radius: 50%;
  background: #0f4c81;
  flex-shrink: 0;
}

.feature-title {
  margin-bottom: 4px;
  font-size: 16px;
  color: #0b2238;
  font-family: 'Aileron-Bold', sans-serif;
}

.feature-description {
  font-size: 14px;
  line-height: 1.65;
  color: #52667a;
  font-family: 'Aileron-Regular', sans-serif;
}

.action-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 8px;
  text-decoration: none;
  transition: transform 0.25s ease;
  font-family: 'Aileron-Bold', sans-serif;
}

.btn-primary {
  background: linear-gradient(135deg, #1a7fb0 0%, #0f4c81 100%);
  color: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 76, 129, 0.2);
}

.btn-primary:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, #2196c4 0%, #125a94 100%);
  box-shadow: 0 12px 24px rgba(15, 76, 129, 0.28);
}

.product-image {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  object-position: center;
  border-radius: 12px;
}

@media (max-width: 900px) {
  .content-wrapper {
    grid-template-columns: 1fr;
  }

  .image-content {
    order: -1;
  }

  .btn {
    width: 100%;
  }
}
</style>
